'use strict';

import register from './core';
import '../functions/jquery-global';
import { getIsMobileDevice } from '../functions/common';
import { keys } from '../functions/search-common';

register('external-search', function (element) {
  var $element = $(element),
    $tabs = $(".tab-items button.tab-item"),
    $tabpanel = $("#tabpanel"),
    $select = $element.find('.select__input'),
    $input = $element.find("input:checkbox"),
    $checkbox = $element.find('[data-input="use-alturl"]');
  var isMobile = getIsMobileDevice();

  function getUrl() {
    var json = getCurrentJson(),
      urlTemplate = '';
    if (json.alturl && $input.prop('checked')) {
      urlTemplate = json.alturl;
    }
    else {
      urlTemplate = json.url;
    }

    var searchPhrase = encodeURIComponent($element.find('[data-input="search-phrase"]').val());
    return urlTemplate.replace('{0}', searchPhrase);
  }

  function getCurrentJson() {
    if (isMobile) {
      return JSON.parse($select.val());
    }
    var value = $(".tab-items .tab-item.active").attr('value');
    return JSON.parse(value);
  }

  function switchTab(e) {
    var $target = $(e);
    $tabs.removeClass('active');
    $tabs.attr('aria-selected', false)
    $tabs.attr("tabindex", -1);
    $target.toggleClass('active')
    $target.attr('aria-selected', true)
    $target.attr("tabindex", 0);

    var controller = $target.attr('aria-controls')
    $input.prop('checked', false)

    var json = getCurrentJson(),
      $info = $('#external-search__info'),
      $infoText = $('.external-search__text'),
      $filterTitle = $('.filter__title'),
      $filterToolTip = $('.filter__tool-tip'),
      $useAlturl = $element.find('[data-input="use-alturl"]'),
      $useAlturlInfo = $element.find('[data-input="use-alturl-info"]');

    $infoText.html(json.info ? json.info : '');
    json.info ? $infoText.show() : $infoText.hide();

    if (json.alturl) {
      $useAlturl.css({ "display": "initial", "visibilty": "initial" });
    }
    else {
      $useAlturl.css({ "display": "none", "visibilty": "hidden"})
    }
    $useAlturlInfo.text(json.altUrlInfoText ? json.altUrlInfoText : '-');

    var display = isMobile ? "block" : "flex";
    json.info || json.alturl ? $info.slideDown({ start: function () { $(this).css({ display: display }) } }) : $info.slideUp();

    $filterTitle.text(json.searchBoxHeadline ? json.searchBoxHeadline : '');

    if (isMobile) {
      $filterToolTip.text(json.toolTipText ? json.toolTipText : '')
      json.toolTipText ? $filterToolTip.show() : $filterToolTip.hide();
    }

    if (!json.alturl) {
      $useAlturl.find('[type="checkbox"]').prop('checked', false);
    }
    $tabpanel.attr("aria-labelledby", controller);
    $tabpanel.focus();
  }

  $select.on('change', function () { switchTab(this) });

  $checkbox.on('keydown', function (e) {
    if (e.keyCode == keys.enter || e.keyCode == keys.space) {
      e.preventDefault();
      $input.prop('checked', !$input.prop('checked'))
    }
  });

  $tabs.on('click', function () { switchTab(this) });
  
  $tabs.on('keydown', function (e) {
    if (e.keyCode == keys.enter || e.keyCode == keys.space) {
      switchTab(this);
    }

    if (e.keyCode != keys.tab) {
       e.preventDefault();
    }
    var isArrowsPressed = (e.keyCode === keys.left || e.keyCode === keys.right || e.keyCode === keys.up || e.keyCode === keys.down || e.keyCode === keys.home || e.keyCode === keys.end);

    if (!isArrowsPressed) {
      return;
    }
    var tab_count = $tabs.length;
    var current_active_tab = 0;
    var each_counter = 0;
    $tabs.each(function () {
      if ($(this).is(":focus")) {
        current_active_tab = each_counter;
      }
      each_counter++;
    });

    if (e.keyCode === keys.left || e.keyCode === keys.up) {
      current_active_tab -= 1;
    }
    else if (e.keyCode === keys.right || e.keyCode === keys.down) {
      current_active_tab += 1;
    }
    else if (e.keyCode === keys.end) {    
      current_active_tab = tab_count - 1;
    }
    if (current_active_tab === tab_count || e.keyCode === keys.home) {
      current_active_tab = 0;
    }
    $tabs.eq(current_active_tab).focus();
  });

  $('#external-search__search-submit').on('click', function (e) {
    e.preventDefault();
    window.open(getUrl(), '_blank').focus();
  });

  $tabs.first().trigger('click');
});
